import { Switch } from "@/components/ui/switch";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import SpiceSelector from "@/components/lib/SpiceSelector";
import { PenLine, Trash2 } from "lucide-react";
import { spiceLevels } from "@/assets/constans";
import CreateVariantDialog from "@/components/dialog/menu-manage/common-dialog/create-variant-dialog";
import UpdateVariantDialog from "@/components/dialog/menu-manage/common-dialog/update-variant-dialog";
import CreateSalad from "@/components/dialog/menu-manage/common-dialog/create-salad";
import CreateSauce from "@/components/dialog/menu-manage/common-dialog/create-sauce";
import CreateAllergenDialog from "@/components/dialog/menu-manage/common-dialog/create-allergen";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "@/components/ui/table";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { calculatePriceWithVAT } from "@/lib/utils";
import { ButtonType } from "@/components/lib/Button";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { deleteVariantById } from "@/redux/slice/essential-menu-slice/variants-slice";
import { DeleteConfirmDialog } from "@/components/dialog/common-dialog";
import {
  fetchSingleBurger,
  updateExistingBurger,
} from "@/redux/slice/menu-manage-slice/burger-slice";
import { setItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import { Loader2 } from "lucide-react";

function Step2({ form, burger_id, item_id }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const allergen_ids = form.watch("allergen_ids");
  const spice_level = form.watch("spice_level");
  const [showSpice, setShowSpice] = useState(false);
  const [showAllergen, setShowAllergens] = useState(false);
  const [createVariantDialog, setCreateVariantDialog] = useState(false);
  const [updateVariantDialog, setUpdateVariantDialog] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [createNewAllergen, setCreateNewAllergen] = useState(false);
  const [saladDialog, setSaladDialog] = useState(false);
  const [toppingsDialog, setSauceDialog] = useState(false);
  const { itemVariants } = useSelector((state) => state.essentialMenu.variants);
  const { salads } = useSelector((state) => state.essentialMenu.salads);
  const { sauces } = useSelector((state) => state.essentialMenu.sauces);
  const { allergens } = useSelector((state) => state.essentialMenu.allergens);

  useEffect(() => {
    const fetchSingleItem = async () => {
      try {
        const res = await dispatch(fetchSingleBurger(item_id));
        if (fetchSingleBurger.fulfilled.match(res)) {
          const item = res?.payload?.variants;
          dispatch(setItemVariants(item));
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchSingleItem();
  }, []);

  const handleVariantCreated = async (newVariantId) => {
    console.log(newVariantId);
    if (!newVariantId) return;
    setLoading(true);
    const allVariantIds = [...itemVariants.map((v) => v.id), newVariantId];
    form.setValue("variant_ids", allVariantIds);
    try {
      const res = await dispatch(
        updateExistingBurger({
          id: item_id,
          data: {
            status: `${
              form.watch("type") === "update" ? form.watch("status") : "draft"
            }`,
            variant_ids: allVariantIds,
          },
        })
      );
      if (updateExistingBurger.fulfilled.match(res)) {
        // toast.success("Drink updated with new variant successfully.");
      } else {
        // toast.error(res?.payload || "Failed to update the drink.");
      }
    } catch (error) {
      // console.log(error)
      toast.error("Failed to update the item with new variant.");
    }
    setLoading(false);
  };

  useEffect(() => {
    setShowSpice(!!spice_level);
    if (Array.isArray(allergen_ids) && allergen_ids.length > 0) {
      setShowAllergens(true);
    } else {
      setShowAllergens(false);
    }
  }, [spice_level, allergen_ids]);

  const closeVariant = () => {
    setCreateVariantDialog(false);
  };
  const closeUpdateVariant = () => {
    setUpdateVariantDialog(false);
    setSelectedVariant(null);
  };
  const closeNewAllergen = () => {
    setCreateNewAllergen(false);
  };

  const deleteHandler = async (id) => {
    try {
      if (!id) {
        toast.error("Variant ID is required to delete.");
        return;
      }
      const res = await dispatch(deleteVariantById(id));
      if (deleteVariantById.fulfilled.match(res)) {
        toast.success("Variant deleted successfully.");
        handleVariantCreated(id);
        setSelectedVariant(null);
        setDeleteDialog(false);
      } else if (deleteVariantById.rejected.match(res)) {
        toast.error(res?.payload || "Failed to delete the variant.");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    }
  };

  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {" "}
          {form.watch("type") == "update" ? "Update Burger" : "Add New Burger"}
        </CardTitle>
        <CardDescription className="text-cyellow">
          Item name: {form.watch("name") || "No name"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="mb-5">
          <FormInputField
            name="size"
            type="text"
            label="Size"
            style="w-full bg-cblack7"
            placeholder="1/4 B"
            form={form}
          />
        </div>
        <div className="space-y-5">
          <div className="flex justify-between items-center gap-5">
            <CardTitle className="text-base">Varinat & Price</CardTitle>
            <ButtonType onClick={() => setCreateVariantDialog(true)}>
              Create New Variants & Price
            </ButtonType>
            <CreateVariantDialog
              title={"Create New Variant & Price"}
              menu_id={burger_id}
              onClose={closeVariant}
              isOpen={createVariantDialog}
              onSuccess={(newVariantId) => handleVariantCreated(newVariantId)}
              item_id={item_id}
              item_type="burger"
            />
          </div>

          <div className="relative">
            <Table>
              <TableHeader>
                <TableRow>
                  {/* <TableHead>Select</TableHead> */}
                  <TableHead>Variant</TableHead>
                  <TableHead>Calories</TableHead>
                  <TableHead>In-Price(exc VAT)</TableHead>
                  <TableHead>In-Price(inc VAT)</TableHead>
                  <TableHead>Out-Price(exc VAT)</TableHead>
                  <TableHead>Out-Price(inc VAT)</TableHead>
                  <TableHead className="text-right">Action</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody>
                {itemVariants && itemVariants.length > 0 ? (
                  itemVariants.map((item, index) => {
                    // const isChecked = form
                    //   .watch("variant_ids")
                    //   ?.includes(item.id);

                    return (
                      <TableRow key={index}>
                        {/* <TableCell>
                        <Checkbox
                          checked={isChecked}
                          onCheckedChange={(checked) => {
                            const currentIds =
                              form.getValues("variant_ids") || [];
                            if (checked) {
                              form.setValue("variant_ids", [
                                ...currentIds,
                                item.id,
                              ]);
                            } else {
                              form.setValue(
                                "variant_ids",
                                currentIds.filter((id) => id !== item.id)
                              );
                            }
                          }}
                        />
                      </TableCell> */}
                        <TableCell>{item?.name || "No name"}</TableCell>
                        <TableCell className="font-medium">
                          {item?.calorie_amount || "0"} kcal
                        </TableCell>
                        <TableCell>${item?.in_price || "0"}</TableCell>
                        <TableCell>
                          ${calculatePriceWithVAT(item?.in_price, 0) || "0"}
                        </TableCell>
                        <TableCell>${item?.out_price || "0"}</TableCell>
                        <TableCell>
                          ${calculatePriceWithVAT(item?.out_price, 0) || "0"}
                        </TableCell>
                        <TableCell>
                          <div className="flex gap-2 justify-end items-center">
                            <span>
                              <PenLine
                                onClick={() => {
                                  setUpdateVariantDialog(true);
                                  setSelectedVariant(item);
                                }}
                                className="text-cgreen cursor-pointer"
                                size={18}
                              />
                            </span>
                            <Trash2
                              onClick={() => {
                                setDeleteDialog(true);
                                setSelectedVariant(item);
                              }}
                              className="text-cred cursor-pointer"
                              size={18}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} className="text-center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            {/* Loading overlay */}
            {loading && (
              <div className="absolute inset-0 bg-black/40 flex justify-center items-center z-10">
                <Loader2 className="animate-spin" size={18} />
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-8 mt-5">
          <div className="flex justify-between items-end gap-5">
            <div className="flex flex-col w-full">
              <div className="w-full mt-3">
                <FormInputField
                  name="salad_ids"
                  style="bg-cblack7 flex-1"
                  placeholder={"Select Salad"}
                  form={form}
                  type="multiselect"
                  label={"Salad"}
                  selectOption={
                    salads && salads?.length > 0
                      ? salads
                        .filter((item) => item?.status === "active")
                        .map((item) => ({
                          label: item.name,
                          value: item.id,
                        }))
                      : [
                          {
                            label: "No brand available",
                            value: "",
                            disabled: true,
                          },
                        ]
                  }
                />
              </div>
            </div>

            <ButtonType onClick={() => setSaladDialog(true)}>
              Create New Salad
            </ButtonType>
            <CreateSalad
              title={"Create New Salad"}
              menu_id={burger_id}
              onClose={() => setSaladDialog(false)}
              isOpen={saladDialog}
            />
          </div>

          <div className="flex justify-between items-end gap-5">
            <div className="flex flex-col w-full">
              <div className="w-full mt-3">
                <FormInputField
                  name="sauce_ids"
                  type="multiselect"
                  label="Sauce"
                  style="w-full bg-cblack7"
                  placeholder="Select Sauce"
                  selectOption={
                    sauces && sauces?.length > 0
                      ? sauces
                        .filter((item) => item?.status === "active")
                        .map((item) => ({
                          label: item.name,
                          value: item.id,
                        }))
                      : [
                          {
                            label: "No brand available",
                            value: "",
                            disabled: true,
                          },
                        ]
                  }
                  form={form}
                />
              </div>
            </div>

            <ButtonType onClick={() => setSauceDialog(true)}>
              Create New Sauce
            </ButtonType>
            <CreateSauce
              title={"Create New Sauce"}
              menu_id={burger_id}
              onClose={() => setSauceDialog(false)}
              isOpen={toppingsDialog}
            />
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full">
                <div className="flex gap-2 items-center">
                  <Switch
                    checked={showAllergen}
                    onCheckedChange={(val) => {
                      setShowAllergens(val);
                      if (!val) {
                        form.setValue("allergen_ids", []);
                      }
                    }}
                  />
                  <Label>
                    Allergen{" "}
                    <span className="text-sm font-light">(shows on items)</span>
                  </Label>
                </div>
                {showAllergen && (
                  <div className="space-y-2 flex mt-2 w-full">
                    <FormInputField
                      name="allergen_ids"
                      style="bg-cblack7 flex-1"
                      placeholder={"Select Allergens"}
                      form={form}
                      type="multiselect"
                      label={"Allergens"}
                      selectOption={
                        allergens && allergens?.length > 0
                          ? allergens
                            .filter((item) => item?.status === "active")
                            .map((item) => ({
                              label:
                                item.name +
                                (item?.short_name ? ` (${item.short_name})` : ""),
                              value: item.id,
                            }))
                          : [
                              {
                                label: "Not available",
                                value: "",
                                disabled: true,
                              },
                            ]
                      }
                    />
                  </div>
                )}
              </div>
              {showAllergen && (
                <ButtonType onClick={() => setCreateNewAllergen(true)}>
                  Create New Allergen
                </ButtonType>
              )}
              <CreateAllergenDialog
                menu_id={burger_id}
                title={"Create New Allergen"}
                onClose={closeNewAllergen}
                isOpen={createNewAllergen}
              />
            </div>
          </div>
          <div>
            <div className="flex gap-5 justify-between items-end ">
              <div className="w-full">
                <SpiceSelector form={form} />
              </div>
            </div>
          </div>
        </div>
      </CardContent>

      <UpdateVariantDialog
        onClose={closeUpdateVariant}
        isOpen={updateVariantDialog}
        title="Update New Variant & Price"
        variantData={selectedVariant}
      />

      <DeleteConfirmDialog
        isOpen={deleteDialog}
        onClose={() => setDeleteDialog(false)}
        onConfirm={() => {
          deleteHandler(selectedVariant.id);
        }}
        personName={""}
      />
    </Card>
  );
}

export default Step2;
